module.exports = __webpack_public_path__ + "static/media/vehicle.bc6708c0.png";